import { assertNever } from "@@/shared/assert-never";

const comparisonTypes = [
    "equal",
    "greaterThan",
    "lessThan",
    "equalOrGreaterThan",
    "equalOrLessThan",
] as const;
type ComparisonType = (typeof comparisonTypes)[number];

const compare =
    (comparison: ComparisonType) => (value1: number, value2: number) => {
        switch (comparison) {
            case "equal":
                return value1 === value2;
            case "greaterThan":
                return value1 > value2;
            case "lessThan":
                return value1 < value2;
            case "equalOrGreaterThan":
                return value1 >= value2;
            case "equalOrLessThan":
                return value1 <= value2;
            default:
                assertNever(comparison);
        }
    };

export { compare, comparisonTypes };
export type { ComparisonType };
